import { render, staticRenderFns } from "./actor-experience.vue?vue&type=template&id=072f56fc&scoped=true&"
import script from "./actor-experience.vue?vue&type=script&lang=ts&"
export * from "./actor-experience.vue?vue&type=script&lang=ts&"
import style0 from "./actor-experience.vue?vue&type=style&index=0&id=072f56fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072f56fc",
  null
  
)

export default component.exports